/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { HttpStatusCode } from "./HttpStatusCode";
import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

// required attributes
const ProblemJsonR = t.interface({});

// optional attributes
const ProblemJsonO = t.partial({
  type: withDefault(t.string, "about:blank"),

  title: t.string,

  status: HttpStatusCode,

  detail: t.string,

  instance: t.string
});

export const ProblemJson = t.intersection(
  [ProblemJsonR, ProblemJsonO],
  "ProblemJson"
);

export type ProblemJson = t.TypeOf<typeof ProblemJson>;
